import { Skeleton } from "@material-ui/lab";
import React from "react";

export const EventPreviewLoading = () => {
  // Return a loading skeleton for EventPreview

  return (
    <div className="cw-flex cw-gap-3 cw-items-center">
      <Skeleton className="cw-rounded cw-mr-3" variant="rect" width={50} height={25} />
      <Skeleton className="cw-rounded" variant="rect" width={8} height={30} />
      <Skeleton className="cw-rounded" variant="rect" width={200} height={25} />
    </div>
  );
};
